import React from "react";
import playStore from "../Assets/Playstore_and_App_Store_Icon/playstore.png";
import applestore from "../Assets/Playstore_and_App_Store_Icon/applestore.png";

const Content8 = () => {
  return (
    <section id="ContactUs">
      <div
        style={{
          // backgroundColor: "#FFF2EF",
          paddingTop: 45,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: 30,
          // clipPath: "polygon(0 8%, 100% 0%, 100% 93%, 0% 100%)",
          padding: "0 20px", // Add padding to the sides for smaller screens
        }}
      >
        <div
          style={{
            color: "#000",
            fontWeight: 700,
            textAlign: "center",
            marginTop: "25px",
          }}
          className="content6Head"
        >
          Join MotoDoctor Community:
        </div>
        <hr
          style={{
            width: "5%",
            border: "1.5px solid #FF8264",
          }}
        />
        <div
          style={{
            width: "100%",
            maxWidth: "800px",
            margin: "0 auto",
            textAlign: "center",
            fontSize: "clamp(14px, 1.3vw, 18px)", // responsive font
            lineHeight: "1.7",
            fontWeight: "400",
            color: "#333",
            padding: "0 16px", // safe spacing for mobile
          }}
        >
          Become a part of our growing community of motorcycle enthusiasts who trust MotoDoctor for their on-the-road
          needs. Whether you're a daily commuter or a weekend adventurer, we're here to ensure your journey stays smooth
          and enjoyable. Download MotoDoctor today and experience the freedom of the open road with the confidence that
          help is just a tap away!
        </div>

        <div
          style={{
            display: "flex",
            gap: "20px",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            marginBottom: "40px", // ✅ bottom space
            padding: "0 16px", // ✅ safe padding for mobile
          }}
        >
          <a
            href="https://play.google.com/store/apps/details?id=com.vahaninc.autodoctor"
            target="_blank"
            rel="noreferrer"
            style={{ display: "inline-block" }}
          >
            <img
              src={playStore}
              alt="Play Store"
              style={{
                width: "clamp(140px, 30vw, 180px)", // responsive size
                height: "auto",
              }}
            />
          </a>

          <a
            href="https://apps.apple.com/in/app/motodoctor-rider/id6478849754"
            target="_blank"
            rel="noreferrer"
            style={{ display: "inline-block" }}
          >
            <img
              src={applestore}
              alt="Apple Store"
              style={{
                width: "clamp(140px, 30vw, 180px)", // responsive size
                height: "auto",
              }}
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Content8;
